import useAppStore from "@/context/store";
import { useCallback } from "react";
import HBList from "../HBList";
import TopicCard from "../TopicCard";

export default function TopicList({
  type = "default",
  isExplore = true,
  showLike = false,
  ...props
}) {
  const { column } = useAppStore(({ column }) => ({
    column,
  }));

  const render = useCallback(
    (record, index) => (
      <TopicCard
        style={
          (index + 1) % column !== 0
            ? { marginRight: "16px", marginBottom: "24px" }
            : { marginBottom: "24px" }
        }
        key={record.keyword_id}
        topic={record}
        height={184}
        type={type}
        isExplore={isExplore}
        showLike={showLike}
      />
    ),
    [column, isExplore, showLike, type]
  );

  return (
    <HBList
      disableMasonry={true}
      {...props}
      loginGuide={true}
      uniqueKey="keyword_id"
      render={render}
    />
  );
}
